export default "__VITE_ASSET__C7nRg0nG__"